/**
 * @author czy
 * 功能：结算列表
 */

import { Service } from '@/tools'

export class InvoiceService<T extends TSettle.ApiInvoicePage> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.ApiInvoicePage}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  // 查询列表
  // /api/settle/invoice/v1/invoicePageList
  getInvoicePage = <K extends T['ApiInvoicePageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInvoicePageList', data)
  // 新增销售蓝色发票
  saveSalesInvoice = <K extends T['ApiSaveSalesInvoice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSaveSalesInvoice', data)
  // 新增红色发票
  saveRedInvoice = <K extends T['ApiSaveRedInvoice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSaveRedInvoice', data)
  // 新增采购蓝色发票
  savePurchaseInvoice = <K extends T['ApiSavePurchaseInvoice']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSavePurchaseInvoice', data)
  // 详情 /api/settle/invoice/v1/queryInvoiceDetail
  queryInvoiceDetail = <K extends T['ApiQueryInvoiceDetail']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQueryInvoiceDetail', data)
}
